import React from 'react';
import { observer } from 'mobx-react';
import { mdiFileChart, mdiWeb, mdiMessageAlert, mdiCardAccountDetails, mdiTableOfContents } from '@mdi/js';
import Icon from '@mdi/react';
import { NavLink } from 'react-router-dom';
import './leftSideMenu.scss';

import stores from 'cd-eft/models/Stores';
const { designStore } = stores?.AppStore;

const LeftSideMenuComponent = (props: any) => {
  return (
    <nav className="common-subnav-bar common-side-menu" aria-label="Admin Menu">
      <div className="text-white">Admin</div>

      <NavLink to="/admin" activeClassName="active-common-item" className="common-side-menu-button" exact>
        <Icon path={mdiTableOfContents} title="Content" size={1} />
        <div>Content</div>
      </NavLink>

      <NavLink to="/admin/error-messages" activeClassName="active-common-item" className="common-side-menu-button">
        <Icon path={mdiMessageAlert} title="Error Messages" size={1} />
        <div>Error Messages</div>
      </NavLink>

      <NavLink to="/admin/reports" activeClassName="active-common-item" className="common-side-menu-button">
        <Icon path={mdiFileChart} title="Reports" size={1} />
        <div>Reports</div>
      </NavLink>

      <NavLink
        to="/admin/project-owner"
        activeClassName="active-common-item"
        className="common-side-menu-button"
        data-testid="admin-menu-project-owner"
      >
        <Icon path={mdiCardAccountDetails} title="Project Owner" size={1} />
        <div>Project Owner</div>
      </NavLink>

      <NavLink
        to={
          designStore.projectsStore.currentProject.projectUuid === ''
            ? '/admin/global-preferences'
            : `/admin/global-preferences/${designStore.projectsStore.currentProject.projectUuid}`
        }
        activeClassName="active-common-item"
        className="common-side-menu-button"
      >
        <Icon path={mdiWeb} title="Global Preferences" size={1} />
        <div>Global Preferences</div>
      </NavLink>
    </nav>
  );
};

export const LeftSideAdminMenu = observer(LeftSideMenuComponent);
